import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { TerrainDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';


@Component({
  selector: 'cradua-terrain-container',
  templateUrl: './terrain-container.component.html',
  styleUrls: ['./terrain-container.component.scss']
})
export class TerrainContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  terrains$: Observable<TerrainDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Terrain");
    this.terrains$ = this.gatwayFacade.loadGateway("Terrain");
    this.terrains$.subscribe(data => {
      // console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteTerrain(deletedValue: any) {
    this.gatwayFacade.remove("Terrain", deletedValue);
    // this.store.dispatch(TerrainStoreActions.removeTerrain({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitTerrain(formValue: any) {
    // console.log("form value: ", formValue);
    formValue.Terrains = formValue.Terrains.reverse();
    event.preventDefault();
    const pullData = formValue.Terrains;
    //const newPullData = formValue.Terraines;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllTerrain = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllTerrain.push(pullData[i]);
    }
  }

// check if the addAllTerrain array is not empty, then dispatch the data to the store
   if(addAllTerrain.length !== 0) {
    this.gatwayFacade.add('Terrain', addAllTerrain);
    // this.store.dispatch(TerrainStoreActions.addTerrain({newTerrain: addAllTerrain}));

   }

// dispatch update data to the store
this.gatwayFacade.update('Terrain', allUpdates, ['id']);
    // this.store.dispatch(TerrainStoreActions.updateTerrain({updateTerrain: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}


